angular.module('registrationModule', ['registrationTemplates', 'LocalStorageModule']);

angular.module('registrationModule').config(['localStorageServiceProvider',function (localStorageServiceProvider) {
	localStorageServiceProvider.setPrefix('crApp');
}]);
